module.exports = __webpack_public_path__ + "img/map.3cbf7083.png";